// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"style_modalWrapper__apSM5"};